module.exports = __webpack_public_path__ + "media/src/ui/icons/iconOpenURL-cf1a9a12399ad843f67b14710854b61f.svg";